import React from "react";

import CheckboxChecked from "icons/CheckboxChecked";
import CheckboxUnChecked from "icons/CheckboxUnChecked";
import "./Checkbox.scss";
import classNames from "classnames";

const Checkbox = ({
  label,
  disabled,
  value,
  onCheck,
}: {
  label?: string | React.ReactNode;
  disabled?: boolean;
  value: boolean;
  onCheck: (v: boolean) => void;
}) => {
  return (
    <div className={classNames("checkbox", { disabled: disabled })}>
      <label className="checkbox-label">
        <input
          type="checkbox"
          checked={value}
          onChange={(e) => onCheck(e.target.checked)}
          disabled={disabled}
          className="checkbox-input"
        />
        {value && <CheckboxChecked />}
        {!value && <CheckboxUnChecked />}
        <div>{label}</div>
      </label>
    </div>
  );
};

export default Checkbox;
